import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
export const useLicenseDetails = (isOpen: boolean) => {
  return useQuery(
    ["license_details", isOpen],
    () => {
      return servicesUtils.getService(`/profile/license/details/`);
    },
    {
      enabled: isOpen,
    }
  );
};
